virtualCategoryInterface = {
    FAVORITE_GAMES: 5,
    RECENT_GAMES: 6,
    RECOMMENDED_GAMES: 7,
};

module.exports = {
    virtualCategoryInterface: virtualCategoryInterface,

    userVirtualCategoryInterfaces: [
        Object.values(virtualCategoryInterface),
    ],
}